/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorpreviousweek3Inputs */

const en_menueditorpreviousweek3 = /** @type {(inputs: Menueditorpreviousweek3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One week earlier`)
};

const de_menueditorpreviousweek3 = /** @type {(inputs: Menueditorpreviousweek3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Woche früher`)
};

/**
* | output |
* | --- |
* | "One week earlier" |
*
* @param {Menueditorpreviousweek3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorpreviousweek3 = /** @type {((inputs?: Menueditorpreviousweek3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorpreviousweek3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorpreviousweek3(inputs)
	return de_menueditorpreviousweek3(inputs)
});
export { menueditorpreviousweek3 as "menuEditorPreviousWeek" }